import React, { useState } from 'react';

const FilterData = ({ onFilter, placeHolder, onFilter2, placeHolder2 }) => {
  const [value, setValue] = useState('');
  const [value2, setValue2] = useState('');
  return (
    <div className="mt-3 grid w-full shrink-0 grid-cols-1 gap-3 rounded-md border border-[#e3e8f0] bg-white p-3 shadow-[0_2px_8px_rgba(31,45,61,0.04)] sm:grid-cols-2">
      <label className="flex h-11 min-w-0 items-center rounded-md border border-[#eadbd4] bg-[#fffaf7] px-3 focus-within:border-[#f5874f] focus-within:ring-1 focus-within:ring-[#f5874f]">
        <i className="bi bi-search mr-3 shrink-0 text-[#f5874f]"></i>
        <input
          value={value}
          className="min-w-0 flex-1 bg-transparent text-sm text-[#383f50] outline-none"
          placeholder={placeHolder}
          onChange={(e) => {
            setValue2('');
            setValue(e.target.value);
            onFilter(e.target.value);
          }}
        />
      </label>
      <label className="flex h-11 min-w-0 items-center rounded-md border border-[#eadbd4] bg-[#fffaf7] px-3 focus-within:border-[#f5874f] focus-within:ring-1 focus-within:ring-[#f5874f]">
        <i className="bi bi-search mr-3 shrink-0 text-[#f5874f]"></i>
        <input
          value={value2}
          className="min-w-0 flex-1 bg-transparent text-sm text-[#383f50] outline-none"
          placeholder={placeHolder2}
          onChange={(e) => {
            setValue('');
            setValue2(e.target.value);
            onFilter2(e.target.value);
          }}
        />
      </label>
    </div>
  );
};

export default FilterData;
